var screenPhoneClient;
var currentCall = null;
var explicitDeconnection = false;

window.telnyxStartConnection = async (username, password) => {

    console.log("Calling telnyxStartConnection ");

    screenPhoneClient = new TelnyxWebRTC.TelnyxRTC({
        env: 'production',
        login: username,
        password: password,
        ringtoneFile: './sounds/incoming_call.mp3'
        // iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
        //ringbackFile: './sounds/ringback_tone.mp3'
    });

    screenPhoneClient.on('telnyx.ready', function () {
        console.log("telnyx ready");
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'updateTelnyxStatus', true, "connected");
    });
    // Update UI on socket close
    screenPhoneClient.on('telnyx.socket.close', function () {
        if (!explicitDeconnection) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'updateTelnyxStatus', false, "connection lost, unvalid credentials");
            screenPhoneClient.disconnect();
            telnyxDetachListeners(screenPhoneClient);
        } else {
            explicitDeconnection = false;
        }
    });
    screenPhoneClient.on('telnyx.error', function (error) {
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'updateTelnyxStatus', false, "connection lost due to an error, check the console log");
        console.error('telnyx error:', error);
        screenPhoneClient.disconnect();
        telnyxDetachListeners(screenPhoneClient);
    });
    screenPhoneClient.on('telnyx.notification', telnyxHandleNotification);
    screenPhoneClient.connect();
};

/**
 * Update the UI when the call's state change
 */
function telnyxHandleCallUpdate(call) {
    currentCall = call;
    console.log("currentCall");
    console.log(currentCall);
    switch (call.state) {
        case 'new': // Setup the UI
            break;
        case 'trying': // You are trying to call someone and he's ringing now
            break;
        case 'recovering': // Call is recovering from a previous session
            if (confirm('Recover the previous call?')) {
                currentCall.answer();
            } else {
                currentCall.hangup();
            }
            break;
        case 'ringing': // Someone is calling you
            console.log("ringing");
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'telnyxIncomingCall', call.options.remoteCallerNumber, currentCall.id, currentCall.telnyxSessionId);
            break;
        case 'active': // Call has become active
            break;
        case 'hangup': // Call is over
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'telnyxHangUp');
            break;
        case 'destroy': // Call has been destroyed
            console.log("destroying call");
            currentCall = null;
            break;
    }
}

/**
 * Make a new outbound call
 */
window.telnyxMakeCall = (phoneNumber, callerName, CallerNumber) => { 
    console.log("calling " + phoneNumber);
    const params = {
        callerName: callerName,
        callerNumber: CallerNumber,
        destinationNumber: phoneNumber, // required!
        audio: true,
        video: false,
    };

    currentCall = screenPhoneClient.newCall(params);
}

/**
 * Hangup the currentCall if present
 */

window.telnyxPickUpCall = () => {
    if (currentCall) {
        currentCall.answer();
    }
}
window.telnyxHangUp = () => {
    console.log("telnyxHangUp called");
    if (currentCall) {
        currentCall.hangup();
    }
}

window.telnyxDisconnect = () => {
    explicitDeconnection = true;
    screenPhoneClient.disconnect();
}
function telnyxHandleNotification(notification) {
    switch (notification.type) {
        case 'callUpdate':
            telnyxHandleCallUpdate(notification.call);
            break;
        case 'userMediaError':
            console.log(
                'Permission denied or invalid audio/video params on `getUserMedia`'
            );
            break;
    }
}

function telnyxDetachListeners(client) {
    if (client) {
        client.off('telnyx.error');
        client.off('telnyx.ready');
        client.off('telnyx.notification');
        client.off('telnyx.socket.close');
    }
}